'use client';
import { FaArrowLeft } from 'react-icons/fa6';
import IndustryTab from './IndustryTab';
import { useInView } from 'framer-motion';
import { useAtom } from 'jotai';
import { useRef } from 'react';
import { currentIndustryAtom } from '@/store/industryStore';
import { Industry } from '@/types/types';
import styles from './IndustryStickyNav.module.css';

interface IndustryNavProps {
  industries: Industry[];
}

export default function IndustryStickyNav({ industries }: IndustryNavProps) {
  const [, setCurrentIndustry] = useAtom(currentIndustryAtom);
  const stickyRef = useRef(null);
  const isInView = useInView(stickyRef, { amount: 1, once: false });

  return (
    <div ref={stickyRef} className={`container`}>
      <div
        className={`w-full bg-charcoal ${isInView ? 'block' : 'mx fixed left-0 right-0 top-16 z-50 mx-auto max-w-[1500px] translate-y-1 transform pl-6 lg:pl-10'}`}
      >
        <div
          className={`flex items-center justify-start gap-4 overflow-x-scroll py-4 ${styles.scrollHide}`}
        >
          <button
            onClick={() => setCurrentIndustry(null)}
            className='inline-flex items-center justify-center gap-2 rounded bg-[#51504D] px-4 py-2'
          >
            <FaArrowLeft
              size={14}
              className='!h-[35px] min-w-[35px] max-w-[35px] rounded-full bg-white object-contain p-2 text-[#51504D]'
            />
            <p className='whitespace-nowrap text-sm text-white'>
              All industries
            </p>
          </button>

          {industries?.map((industry, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndustry(industries[index])}
            >
              <IndustryTab
                title={industry.title}
                industryIcon={industry?.industryIcon}
                industryColor={industry?.industryColor}
              />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
